import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatChip, MatChipListbox } from '@angular/material/chips';
import { MatIcon } from '@angular/material/icon';
import { PushPipe } from '@ngrx/component';
import { TrackByFunctions } from '@principle-theorem/ng-shared';
import { type ITag } from '@principle-theorem/principle-core/interfaces';
import { type WithRef } from '@principle-theorem/shared';
import { ReplaySubject } from 'rxjs';
import { PipesModule } from '../../pipes/pipes.module';

@Component({
  selector: 'pr-tag-display-list',
  templateUrl: './tag-display-list.component.html',
  styleUrls: ['./tag-display-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    PushPipe,
    MatIcon,
    MatChipListbox,
    MatChip,
    PipesModule,
  ],
})
export class TagDisplayListComponent {
  trackByTag = TrackByFunctions.ref<WithRef<ITag>>();
  tags$ = new ReplaySubject<WithRef<ITag>[]>(1);
  @Input() compact = false;

  @Input()
  set tags(tags: WithRef<ITag>[]) {
    if (tags) {
      this.tags$.next(tags);
    }
  }
}
